// extracted by mini-css-extract-plugin
module.exports = {"socialIconGroupWrapper":"social-icon-group_socialIconGroupWrapper__2x0VL","socialIconImage":"social-icon-group_socialIconImage__34-n9"};